var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUniversalCurrencyAlt = function SvgUniversalCurrencyAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "universal_currency_alt_svg__a",
    width: 17,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .001h17v17H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#universal_currency_alt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M3.054 13.105q-.536 0-.909-.372a1.24 1.24 0 0 1-.372-.909V5.177q0-.536.372-.909.372-.372.909-.372H13.95q.537 0 .909.372t.372.909v6.647q0 .537-.372.909-.371.372-.909.372zm0-1.063H13.95a.2.2 0 0 0 .15-.068.2.2 0 0 0 .068-.15V5.177a.2.2 0 0 0-.068-.15.2.2 0 0 0-.15-.068H3.054a.2.2 0 0 0-.15.068.2.2 0 0 0-.068.15v6.647q0 .082.068.15a.2.2 0 0 0 .15.068m9.453-1.662H11.16a.41.41 0 0 0-.423.423.41.41 0 0 0 .423.422h1.553a.62.62 0 0 0 .457-.183.62.62 0 0 0 .183-.457V9.032a.41.41 0 0 0-.422-.422.41.41 0 0 0-.423.422zm-4.004.028q.79 0 1.348-.559.559-.558.559-1.348T9.85 7.152a1.84 1.84 0 0 0-1.348-.558q-.79 0-1.349.558a1.84 1.84 0 0 0-.558 1.349q0 .79.558 1.348.558.56 1.349.559M4.498 6.62h1.348a.41.41 0 0 0 .423-.422.41.41 0 0 0-.423-.423H4.294a.62.62 0 0 0-.458.184.62.62 0 0 0-.183.457v1.552a.41.41 0 0 0 .423.423.41.41 0 0 0 .422-.423z"
  }))));
};
export default SvgUniversalCurrencyAlt;